import config from "./config";
var axios = config();

export default {
  // get
  getTerms(amount) {
    return axios.get("/api/Overrides/GetTerms?amount=" + amount);
  },

  getDistinctTerms() {
    return axios.get("/api/Overrides/GetDistinctTerms");
  },

  getReasons() {
    return axios.get("/api/Overrides/GetReasons");
  },

  getCourseOverrides() {
    return axios.get("/api/Overrides/GetCourseOverrides");
  },

  getCourseOverridesByAsuriteId(asuriteId) {
    return axios.get(
      "/api/Overrides/GetCourseOverridesByAsuriteId/" + asuriteId
    );
  },

  getCourseOverrideById(id) {
    return axios.get("/api/Overrides/GetCourseOverrideById/" + id);
  },

  getFilesByCourseOverrideId(id) {
    return axios.get("/api/Overrides/GetFilesByCourseOverrideId/" + id);
  },

  getOverrideCourseCounts(termCode) {
    return axios.get(
      "/api/Overrides/GetOverrideCourseCounts?termCode=" + termCode
    );
  },

  getOverrideReasonCounts(termCode) {
    return axios.get(
      "/api/Overrides/GetOverrideReasonCounts?termCode=" + termCode
    );
  },

  getCourseById(id) {
    return axios.get("/api/Overrides/GetCourseById/" + id);
  },

  getCourses(termCode, query) {
    return axios.get("/api/Overrides/GetCourses?termCode=" + termCode + "&query=" + query)
  },

  // post
  createOverride(override) {
    return axios.post("/api/Overrides/CreateOverride", override);
  },

  createOverrideEmail(override) {
    return axios.post("/api/Overrides/CreateOverrideEmail/" + override);
  },

  createOverrideReasonDefinition(reason) {
    return axios.post("/api/Overrides/CreateOverrideReasonDefinition", reason);
  },

  //put
  editOverrideReasonDefinition(reason) {
    return axios.put("/api/Overrides/EditOverrideReasonDefinition", reason);
  },

  // delete
  deleteOverrideReasonDefinition(id) {
    return axios.delete("/api/Overrides/DeleteOverrideReasonDefinition/" + id);
  }
};
